export enum USComplianceCategoryEnum {
        HumanResourceComplianceFormFiles = 20,
        StateLawAndForms = 21,
        AdditionalOnlineFormsAndPostersLibrary = 22,
}